module.exports = __webpack_public_path__ + "img/xtractive-brun.dda0ddbf.png";